import { backendBaseUrl } from "../../configs/environment";

export const apiV1Endpoint = `${backendBaseUrl}/api/v1`;
